module.exports = __webpack_public_path__ + "img/kz.kzac6fa1a.svg";